module.exports = __webpack_public_path__ + "static/media/Bottom_Building_Light.da73ec7d.png";